import {Component, Input} from '@angular/core';
import {Address, B2BUser} from '@spartacus/core';

@Component({
  selector: 'dcp-payment-method-invoice',
  templateUrl: './payment-method-invoice.component.html',
  styleUrls: ['./payment-method-invoice.component.scss'],
})
export class PaymentMethodInvoiceComponent {
  @Input() invoiceContacts: B2BUser[];
  @Input() invoiceAddresses: Address[];
}
